<div class="logo-container">
  <img class="logo" [src]="logo" alt="Logo" />
</div>
